const app = {
    pages: {},
    slides: {},
    history: {},
};

export default app;



// WEBPACK FOOTER //
// ./src/service/app.js